type Highlight = {
  label: string;
  title: string;
  body: string;
};

export function EditorialHighlights({ label, items }: { label: string; items: readonly Highlight[] }) {
  return (
    <section className="editorial-highlights band-light" aria-label={label}>
      <div className="container">
        {items.map((item, index) => (
          <article className="editorial-highlight reveal" key={item.title}>
            <div className="editorial-highlight-index">
              <span className="editorial-highlight-number">{String(index + 1).padStart(2, '0')}</span>
              <span>{item.label}</span>
            </div>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
